import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'reactstrap'

class DateInput extends React.Component {

    static propTypes = {
        name: PropTypes.string,
        date: PropTypes.oneOfType([ PropTypes.number,PropTypes.string ]),
        onDateChange: PropTypes.func
    }

    handleInputChange = e => {
        this.props.onDateChange(e)
    }

    render() {
        const date = this.props.date
        const name = this.props.name
        return (
            <Input
                type="date"
                name={ name }
                value={ date }
                onChange={ this.handleInputChange }
                required pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}" />
        )
    }
}
export default DateInput
